<script>
import { mapGetters } from 'vuex'
import { formatPriceWithSign } from '@/utils/helpers'
import SidebarPenalties from '@/components/cart/ui/SidebarPenalties.vue'

export default {
  name: 'additional-sidebar',
  components: {
    SidebarPenalties
  },
  props: {},
  data: () => ({
    agencyPrice: false,
    userAgree: false
  }),
  computed: {
    isUserLoggedIn() {
      return this.$store.getters['account/getAccess']
    },
    getCartPrices() {
      return this.$store.getters['cart/getCartPrice']
    },
    servicesList() {
      const services = this.$store.getters['cart/getCartServices']

      return {
        main: services.filter(service => service.main && service.amount),
        additional: services.filter(service => !service.main && service.amount)
      }
    },
    getAllPenalties() {
      return this.$store.getters['cart/getAllPenalties']
    },
    bookingIsLoading() {
      return this.$store.state.cart.bookingIsLoading
    },
    ...mapGetters('account', [
      'checkBookingAccess',
      'checkAgencyPriceAccess'
    ])
  },
  created() {
    this.$store.dispatch('getDictionary', {
      params: {},
      config: {
        dictionaryName: 'currencies',
        target: 'cart.dictionaries.currencies'
      }
    })
  },
  methods: {
    formatPrice(price) {
      const slug = this.$store.getters['cart/getCartPrice'].currency
      const dictionary = this.$store.getters.getDictionary('cart.dictionaries.currencies')

      return formatPriceWithSign(price, slug, dictionary)
    },
    submit() {
      if (this.userAgree) {
        const {
          adults,
          children
        } = this.$store.getters['cart/getNumberOfTourists']

        this.$store.dispatch('order/booking', {
          orderId: this.$store.getters['order/getOrderInfo'].id,
          tourists: this.$store.getters['order/getTouristsForSearch'],
          bookingInfo: {
            adults,
            children,
            meetingPlace: this.$store.getters['cart/getHotelInfo'].name,
            ...this.$store.getters['cart/getIds'].hotel,
            hotelId: null,
            ...this.$store.getters['cart/getIds'].medicalInsurance,
            ...this.$store.getters['cart/getIds'].cancelInsurance,
            ...this.$store.getters['cart/getIds'].transfer,
            ...this.$store.getters['cart/getIds'].aviaticket,
            ...this.$store.getters['cart/getIds'].excursion,
            ...this.$store.getters['cart/getIds'].visa,
            ...this.$store.getters['cart/getTransfersFlightIds']
          }
        })
      }
    }
  },
}
</script>

<template>
  <div
    v-if="servicesList.additional.length"
    class="sidebar app-sidebar"
  >
    <div class="sidebar__content">
      <p class="sidebar__title">
        Дополнительные услуги
      </p>
      <div
        v-for="item in servicesList.additional"
        :key="item.key"
        class="sidebar__service-price"
      >
        <span>{{ item.name }}</span>
        <span>{{ formatPrice(item.amount) }}</span>
      </div>
      <div
        v-if="agencyPrice"
        class="sidebar__service-price sidebar__service-price--total"
      >
        <span>Итого</span>
        <span>{{ formatPrice(getCartPrices.amountAgency) }}</span>
      </div>
      <div
        v-else
        class="sidebar__service-price sidebar__service-price--total"
      >
        <span>Итого</span>
        <span>{{ formatPrice(getCartPrices.amount) }}</span>
      </div>
      <div
        v-if="agencyPrice"
        class="sidebar__service-price sidebar__service-price--markup"
      >
        <span>Комиссия</span>
        <span>{{ formatPrice(getCartPrices.markup) }}</span>
      </div>
      <div
        v-if="checkAgencyPriceAccess"
        class="sidebar__markup-trigger"
      >
        <span>Показать цену агента</span>
        <b-switch
          v-model="agencyPrice"
          size="is-small"
        />
      </div>
      <div class="sidebar__links">
        <div class="sidebar__links-item">
          <sidebar-penalties />
        </div>
      </div>
      <a
        v-if="checkBookingAccess"
        href="javascript:;"
        :class="[
          { disabled: !userAgree },
          { loading: bookingIsLoading }
        ]"
        class="sidebar__btn rex-btn-main"
        @click="submit"
      >
        <b-loading
          v-if="bookingIsLoading"
          :is-full-page="false"
          :active="bookingIsLoading"
        />
        Добавить к заказу
      </a>
      <b-checkbox
        v-if="checkBookingAccess"
        v-model="userAgree"
        class="rex-black sidebar__agreement"
      >
        Я согласен с условиями бронирования
      </b-checkbox>
    </div>
  </div>
</template>
